import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import {
  Suspense,
  Loader,
  Tabs,
  TabsItem,
  Gutter,
  ToastUtil,
  CondensedLarge,
  Banner,
} from '@axiom/ui';

import { useEngagementTalentData } from '../../hooks/useEngagementTalentData';
import { useEngagementInterviewTalentData } from '../../hooks/useEngagementInterviewTalentData';
import { MyEngagementsProcessSteps } from '../MyEngagementsProcessSteps/MyEngagementsProcessSteps';

export const MyEngagementsItem = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { submission, matchesCount } = useEngagementTalentData();
  const { interviewCount } = useEngagementInterviewTalentData();
  const onKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
      event.preventDefault();
      const toastName = `PREVENTPRINT`;
      const toasts = ToastUtil.getAll();
      const alreadyOpen = toasts.some(toast => toast.name === toastName);
      if (!alreadyOpen) {
        ToastUtil.add({
          name: toastName,
          type: 'info',
          children: (
            <CondensedLarge>
              To print this page, click “Share” at the top right of the screen,
              and then choose “Download All Matches".
            </CondensedLarge>
          ),
        });
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);

  const renderStartTab = () => {
    if (location.pathname.includes('interviews')) {
      return 'interviews';
    } else if (location.pathname.includes('engagement-details')) {
      return 'engagement-details';
    }
    return 'matches';
  };

  return (
    <>
      {!submission?.isQualificationComplete && (
        <Gutter top="16px">
          <Banner name="qualification-banner">
            You’ll be able to take action on these talent matches as soon as we
            confirm a few engagement details.
          </Banner>
        </Gutter>
      )}
      <Gutter top="16px">
        <MyEngagementsProcessSteps submission={submission} />
      </Gutter>
      <Suspense fallback={<Loader type="bars" />}>
        <Gutter top="16px" />
        <Tabs startTab={renderStartTab()} name="engagement-view">
          <TabsItem
            label="Details"
            name="engagement-details"
            onClick={() => {
              void navigate('./engagement-details');
            }}
          >
            <Gutter bottom="16px" />
            <Outlet />
          </TabsItem>
          <TabsItem
            label="Matches"
            name="matches"
            onClick={() => {
              void navigate('./matches');
            }}
            countBadge={matchesCount}
          >
            <Gutter bottom="16px" />
            <Outlet />
          </TabsItem>
          <TabsItem
            label="Interviews"
            name="interviews"
            onClick={() => {
              void navigate('./interviews');
            }}
            countBadge={interviewCount}
          >
            <Gutter bottom="16px" />
            <Outlet />
          </TabsItem>
        </Tabs>
      </Suspense>
    </>
  );
};
